import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import { createStyles, makeStyles } from "@material-ui/core";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Box,
  Button,
  FormControl,
  Grid,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import ChipCmp from "../../../components/chip/chipCmp";
import DatePickerComponents from "../../../components/datePicker/DatePickerComponents";
import Autocomplate from "../../../components/dropdown/Autocomplate";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { ColumnModel, PageInfoModel } from "../../../models/common.model";
import { GetEnumsResponse } from "../../../models/enum.model";
import { PaginationInfo } from "../../../models/security.model";
import {
  GetSettlementRequestsResponse,
  SettlementListFilter,
} from "../../../models/settlement.model";
import { convertDate } from "../../../utility/convertDate";
import { commaSeparatedToNum } from "../../../utility/commaSepratedToNum";
import { commaSeprator } from "../../../utility/commaSeprator";
import { useDispatch, useSelector } from "react-redux";
import {
  getTablePage,
  getTableSelectedRow,
} from "../../../redux/table/tableSlice";
import { useHistory } from "react-router-dom";
import AutocomplateCheckbox from "../../../components/dropdown/AutocomplateCheckbox";

const columns: readonly ColumnModel[] = [
  { id: "settlementType", label: "نوع تسویه" },
  { id: "creatorName", label: "ثبت کننده" },
  { id: "createDatePersian", label: "تاریخ ثبت" },
  {
    id: "factorAmount",
    label: "(ریال) مبلغ فاکتور",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "settlementAmount",
    label: "(ریال) مبلغ تسویه",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  { id: "creatorDescription", label: "توضیحات" },
];

const useStyles = makeStyles(() =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: "#CEE5D3 !important",
      },
    },
  })
);
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

interface Props {
  handleDownload: Function;
  handleCheck: Function;
  handleDelete: Function;
  handleRowAction: Function;
  settlementRequestsList: GetSettlementRequestsResponse[];
  settlementTypes: GetEnumsResponse[];
  setFilterObject: (obj: SettlementListFilter) => void;
  pageInfo: PageInfoModel;
  setCurrentPaginationInfo: (page: any) => void;
  currentPaginationInfo: any;
  handleExportExcel: Function;
}

const SettelmentWithSuppliersTable = ({
  handleCheck,
  handleDelete,
  handleDownload,
  handleRowAction,
  settlementRequestsList,
  settlementTypes,
  setFilterObject,
  pageInfo,
  currentPaginationInfo,
  setCurrentPaginationInfo,
  handleExportExcel,
}: Props) => {
  const [valueSettlementTypes, setValueSettlementTypes] = useState<any[]>([]);
  const classes = useStyles();
  const [formData, setFormData] = useState<SettlementListFilter>();
  const [requestDate, setRequestDate] = useState<Date[] | null | undefined>(
    null
  );
  const [showFilter, setShowFilter] = useState(true);
  const [
    valueSettlementTypesOptions,
    setValueSettlementTypesOptions,
  ] = useState<number[]>([]);

  const [valueConfirmDatePersian, setValueConfirmDatePersian] = useState<
    string
  >();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const tableInfo = useSelector((state: any) => state.table);
  const history = useHistory<any>();

  const handleChangeForm = (event: any) => {
    const includeIds = [
      "factorAmountFrom",
      "factorAmountTo",
      "settlementAmountFrom",
      "settlementAmountTo",
    ];
    setFormData({
      ...formData!,
      [event.target.id]: includeIds.includes(event.target.id)
        ? event.target.value.replace(/,/g, "")
        : event.target.value,
    });
    queryClient.setQueryData<SettlementListFilter>("SettlementRequestList", {
      ...formData!,
      [event.target.id]: includeIds.includes(event.target.id)
        ? event.target.value.replace(/,/g, "")
        : event.target.value,
    });
  };
  const nextIcon = () => {
    return (
      <img
        style={{ height: "12px", width: "10px" }}
        src='images/Next.png'
        alt=''
      />
    );
  };
  const previusIcon = () => {
    return (
      <img
        style={{ height: "12px", width: "10px" }}
        src='images/Previous.png'
        alt=''
      />
    );
  };
  function changeValueRequestDate(e: any) {
    setValueConfirmDatePersian(e.toString().replace(/,/g, " - "));
    setRequestDate(e);
  }

  function changeValueSettlementTypesOptions(e: any, value: any) {
    setValueSettlementTypesOptions([...value]);
    setValueSettlementTypes([...e]);
  }

  function deleteChip() {
    const tableFilter = queryClient.getQueryData<SettlementListFilter>(
      "SettlementRequestList"
    );
    tableFilter!.creatorName = undefined;
    tableFilter!.factorAmountFrom = undefined;
    tableFilter!.factorAmountTo = undefined;
    tableFilter!.settlementAmountFrom = undefined;
    tableFilter!.settlementAmountTo = undefined;
    setFormData({
      ...formData!,
      creatorName: "",
      factorAmountFrom: 0,
      factorAmountTo: 0,
      settlementAmountFrom: 0,
      settlementAmountTo: 0,
    });
    setValueConfirmDatePersian(undefined);
    setValueSettlementTypes([]);
    queryClient.setQueryData<SettlementListFilter>(
      "SettlementRequestList",
      tableFilter!
    );
    setRequestDate(undefined);
    setFilterObject({});
  }

  const setChildCreatorName = () => {
    let tableFilter = queryClient.getQueryData<SettlementListFilter>(
      "SettlementRequestList"
    );
    setFormData({ ...formData!, creatorName: "" });
    tableFilter = { ...tableFilter!, creatorName: undefined };
    queryClient.setQueryData<SettlementListFilter>(
      "SettlementRequestList",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildFactorAmountFrom = () => {
    let tableFilter = queryClient.getQueryData<SettlementListFilter>(
      "SettlementRequestList"
    );
    tableFilter = { ...tableFilter!, factorAmountFrom: undefined };
    setFormData({ ...formData!, factorAmountFrom: 0 });
    queryClient.setQueryData<SettlementListFilter>(
      "SettlementRequestList",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildFactorAmountTo = () => {
    let tableFilter = queryClient.getQueryData<SettlementListFilter>(
      "SettlementRequestList"
    );
    setFormData({ ...formData!, factorAmountTo: 0 });
    tableFilter = { ...tableFilter!, factorAmountTo: undefined };
    queryClient.setQueryData<SettlementListFilter>(
      "SettlementRequestList",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildSettlementAmountFrom = () => {
    let tableFilter = queryClient.getQueryData<SettlementListFilter>(
      "SettlementRequestList"
    );
    setFormData({ ...formData!, settlementAmountFrom: 0 });
    tableFilter = { ...tableFilter!, settlementAmountFrom: undefined };
    queryClient.setQueryData<SettlementListFilter>(
      "SettlementRequestList",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildSettlementAmountTo = () => {
    let tableFilter = queryClient.getQueryData<SettlementListFilter>(
      "SettlementRequestList"
    );
    setFormData({ ...formData!, settlementAmountTo: 0 });
    tableFilter = { ...tableFilter!, settlementAmountTo: undefined };
    queryClient.setQueryData<SettlementListFilter>(
      "SettlementRequestList",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };

  const setChildSettlementType = (chip: any) => {
    const selectedItem = valueSettlementTypes.filter(
      (item: any) => item !== chip
    );
    setValueSettlementTypes(selectedItem);
    let tabelFilter = queryClient.getQueryData<SettlementListFilter>(
      "SettlementRequestList"
    );
    if (tabelFilter !== undefined && tabelFilter != null) {
      tabelFilter!.settlementType = tabelFilter!.settlementType
        ?.filter((item: any) => item !== chip)
        .map((items: any) => {
          return items;
        });
    }
    setFilterObject(tabelFilter!);
  };
  const setChildConfirmDate = () => {
    let tableFilter = queryClient.getQueryData<SettlementListFilter>(
      "SettlementHistoryFilter"
    );
    tableFilter = { ...tableFilter!, createDateFrom: undefined };
    queryClient.setQueryData<SettlementListFilter>(
      "SettlementHistoryFilter",
      tableFilter!
    );
    setRequestDate(undefined);
    setValueConfirmDatePersian(undefined);
    setFilterObject(tableFilter!);
  };

  const handleFormSubmit = () => {
    let tableFilter = queryClient.getQueryData<SettlementListFilter>(
      "SettlementRequestList"
    );
    const convertedCreateDate = convertDate(requestDate);
    tableFilter = {
      ...tableFilter!,
      createDateFrom: Array.isArray(convertedCreateDate)
        ? convertedCreateDate[0]
        : convertedCreateDate,
      createDateTo: Array.isArray(convertedCreateDate)
        ? convertedCreateDate[1]
        : undefined,
      settlementType: valueSettlementTypes,
    };
    queryClient.setQueryData<SettlementListFilter>(
      "SettlementRequestList",
      tableFilter
    );
    setCurrentPaginationInfo({
      pageNumber: 1,
      pageSize: 10,
    });
    setFilterObject(tableFilter!);
  };

  const changePageNumber = (newPageNumber: number) => {
    setCurrentPaginationInfo({
      pageNumber: newPageNumber,
      pageSize: 10,
    });
  };

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    dispatch(
      getTableSelectedRow({
        selectedRowNum: 0,
      })
    );
    dispatch(
      getTablePage({
        selectedPageNum: value,
      })
    );
  };
  useEffect(() => {
    if (history.action === "POP") {
      setCurrentPaginationInfo({
        pageNumber: tableInfo.selectedPageNum,
        pageSize: 10,
      });
    }
  }, [history.action, setCurrentPaginationInfo, tableInfo.selectedPageNum]);

  return (
    <div>
      <Grid item sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            borderLeft: "2px solid #DAE0E4",
            paddingLeft: "10px",
            cursor: "pointer",
          }}
        >
          <Tooltip title='فیلتر' arrow>
            <img
              onClick={() => setShowFilter((prev) => !prev)}
              style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
              src='images/filter.png'
              alt=''
            />
          </Tooltip>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
          <Tooltip title='خروجی اکسل' arrow>
            <img
              onClick={() => handleExportExcel()}
              className='cursorPointer'
              style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
              src='images/ExportXLS.svg'
              alt='ExportXLS'
            />
          </Tooltip>
        </Box>
      </Grid>

      {showFilter ? (
        <Box sx={{ flexGrow: 1 }}>
          <div className='row'>
            <div
              className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container '
              style={{ marginTop: "1vh" }}
            >
              <CacheProvider value={cacheRtl}>
                <ThemeProvider theme={theme}>
                  {settlementTypes && (
                    <div dir='rtl'>
                      <AutocomplateCheckbox
                        id='settlementTypes'
                        name='settlementTypes'
                        value={valueSettlementTypesOptions}
                        label={"نوع تسویه"}
                        options={settlementTypes}
                        onChange={changeValueSettlementTypesOptions}
                        changeMultiSelect={changeValueSettlementTypesOptions}
                        responseValue={valueSettlementTypes}
                      />
                    </div>
                  )}
                </ThemeProvider>
              </CacheProvider>
            </div>
            <div
              className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
              style={{ marginTop: "1vh" }}
            >
              <MaterialTextFieldComponent
                helperText={""}
                placeHolder={"ثبت کننده"}
                label={"ثبت کننده"}
                required={false}
                value={formData?.creatorName}
                onChange={(e: any) => handleChangeForm(e)}
                name='creatorName'
                id='creatorName'
              />
            </div>
            <div
              className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
              style={{ marginTop: "1vh" }}
            >
              <FormControl fullWidth className='shadowDatepicker'>
                <DatePickerComponents
                  valueArray={requestDate}
                  // value={new Date(valueRequestDateFrom!)}
                  label={" تاریخ ثبت "}
                  onChange={changeValueRequestDate}
                  range={true}
                />
              </FormControl>
            </div>
            <div
              className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
              style={{ marginTop: "1vh" }}
            >
              <MaterialTextFieldComponent
                helperText={""}
                placeHolder={"مبلغ فاکتور از (ریال)"}
                label={"مبلغ فاکتور از (ریال)"}
                required={false}
                value={
                  formData?.factorAmountFrom
                    ? commaSeprator(formData?.factorAmountFrom)
                    : ""
                }
                onChange={(e: any) => handleChangeForm(e)}
                name='factorAmountFrom'
                id='factorAmountFrom'
                onKeyDown={(event) => {
                  if (
                    event.code === "Space" ||
                    (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                  )
                    event.preventDefault();
                }}
              />
            </div>
            <div
              className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
              style={{ marginTop: "1vh" }}
            >
              <MaterialTextFieldComponent
                helperText={""}
                placeHolder={"مبلغ فاکتور تا (ریال)"}
                label={"مبلغ فاکتور تا (ریال)"}
                required={false}
                value={
                  formData?.factorAmountTo
                    ? commaSeprator(formData?.factorAmountTo)
                    : ""
                }
                onChange={(e: any) => handleChangeForm(e)}
                name='factorAmountTo'
                id='factorAmountTo'
                onKeyDown={(event) => {
                  if (
                    event.code === "Space" ||
                    (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                  )
                    event.preventDefault();
                }}
              />
            </div>
            <div
              className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
              style={{ marginTop: "1vh" }}
            >
              <MaterialTextFieldComponent
                helperText={""}
                placeHolder={"مبلغ تسویه از (ریال)"}
                label={"مبلغ تسویه از (ریال)"}
                required={false}
                value={
                  formData?.settlementAmountFrom
                    ? commaSeprator(formData?.settlementAmountFrom)
                    : ""
                }
                onChange={(e: any) => handleChangeForm(e)}
                name='settlementAmountFrom'
                id='settlementAmountFrom'
                onKeyDown={(event) => {
                  if (
                    event.code === "Space" ||
                    (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                  )
                    event.preventDefault();
                }}
              />
            </div>
            <div
              className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
              style={{ marginTop: "1vh" }}
            >
              <MaterialTextFieldComponent
                helperText={""}
                placeHolder={"مبلغ تسویه تا (ریال)"}
                label={"مبلغ تسویه تا (ریال)"}
                required={false}
                value={
                  formData?.settlementAmountTo
                    ? commaSeprator(formData?.settlementAmountTo)
                    : ""
                }
                onChange={(e: any) => handleChangeForm(e)}
                name='settlementAmountTo'
                id='settlementAmountTo'
                onKeyDown={(event) => {
                  if (
                    event.code === "Space" ||
                    (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                  )
                    event.preventDefault();
                }}
              />
            </div>
            <div
              className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter'
              style={{ marginTop: "1vh" }}
            >
              <Button
                fullWidth
                variant='contained'
                className='btnForm SuccessDefault  '
                onClick={handleFormSubmit}
              >
                اعمال فیلتر
              </Button>
            </div>
          </div>
          {formData?.creatorName ||
          formData?.factorAmountFrom! > 0 ||
          formData?.factorAmountTo! > 0 ||
          formData?.settlementAmountFrom! > 0 ||
          formData?.settlementAmountTo! > 0 ||
          valueSettlementTypes?.length > 0 ||
          valueConfirmDatePersian ? (
            <div
              style={{ display: "flex", alignItems: "center" }}
              className='row tableCMP'
            >
              <Button
                onClick={deleteChip}
                style={{
                  justifyContent: "right",
                  minWidth: "25px",
                  marginRight: "-1vh",
                  marginTop: "1vh",
                }}
              >
                <img
                  style={{ height: "24px", width: "24px" }}
                  src='images/RemoveAllFilters.svg'
                  alt=''
                />
              </Button>

              <ChipCmp
                item={formData?.creatorName}
                enamValue={formData?.creatorName}
                index={formData?.creatorName?.length}
                setChildValue={setChildCreatorName}
              />
              <ChipCmp
                item={formData?.factorAmountFrom}
                enamValue={commaSeparatedToNum(formData?.factorAmountFrom)}
                index={String(formData?.factorAmountFrom)?.length}
                setChildValue={setChildFactorAmountFrom}
              />
              <ChipCmp
                item={formData?.factorAmountTo}
                enamValue={commaSeparatedToNum(formData?.factorAmountTo)}
                index={String(formData?.factorAmountTo)?.length}
                setChildValue={setChildFactorAmountTo}
              />
              <ChipCmp
                item={formData?.settlementAmountFrom}
                enamValue={commaSeparatedToNum(formData?.settlementAmountFrom)}
                index={String(formData?.settlementAmountFrom)?.length}
                setChildValue={setChildSettlementAmountFrom}
              />
              <ChipCmp
                item={formData?.settlementAmountTo}
                enamValue={commaSeparatedToNum(formData?.settlementAmountTo)}
                index={String(formData?.settlementAmountTo)?.length}
                setChildValue={setChildSettlementAmountTo}
              />
              <ChipCmp
                item={valueSettlementTypes}
                enamValue={settlementTypes}
                index={valueSettlementTypes?.length}
                setChildValue={setChildSettlementType}
              />
              <ChipCmp
                item={valueConfirmDatePersian}
                enamValue={valueConfirmDatePersian}
                index={valueConfirmDatePersian?.length}
                setChildValue={setChildConfirmDate}
              />
            </div>
          ) : (
            ""
          )}
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className='cardTableBorder'>
        <TableContainer
          style={{ background: "#fff", maxHeight: "55vh" }}
          className='boxScroll'
        >
          <Table
            stickyHeader
            aria-label='sticky table'
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className='rowTHead' style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                selected={tableInfo.selectedRowNum}
              >
                {columns.map((column) => (
                  <TableCell
                    className='rowTHead colorTitle textFont12 fontWeight noWrap'
                    key={column.id}
                    align='right'
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell
                  className='rowTHead colorTitle textFont12 fontWeight'
                  align='right'
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  <MoreHorizIcon />
                </TableCell>
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {settlementRequestsList
                ? settlementRequestsList.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 === 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft cursorPointer noWrap`}
                        hover
                        role='checkbox'
                        tabIndex={-1}
                        key={row.key}
                        selected={tableInfo.selectedRowNum === rowIndex}
                        onClick={() => {
                          handleRowAction(row.key);
                          dispatch(
                            getTableSelectedRow({
                              selectedRowNum: rowIndex,
                            })
                          );
                        }}
                      >
                        {columns.map((column) => {
                          const value =
                            row[
                              column.id as keyof GetSettlementRequestsResponse
                            ];
                          return (
                            <>
                              {
                                <TableCell
                                  className='textFont12'
                                  key={column.id}
                                  align='right'
                                >
                                  {column.format && column.hasFormat
                                    ? column.format(value)
                                    : value?.toString()}
                                </TableCell>
                              }
                            </>
                          );
                        })}
                        <TableCell
                          sx={{
                            display: "flex",
                            gap: "5px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          align='center'
                          component='th'
                          scope='row'
                        >
                          <FileDownloadOutlinedIcon
                            sx={{ color: "#1D4A87", fontSize: "1.8rem" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDownload(row.key);
                            }}
                          />
                          <CheckOutlinedIcon
                            sx={{ color: "#1D4A87", fontSize: "1.8rem" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCheck(row.settlementAmount, row.key);
                            }}
                          />
                          <ClearOutlinedIcon
                            sx={{ color: "#1D4A87", fontSize: "1.8rem" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(row.settlementAmount, row.key);
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems='center'>
          <Grid
            item
            xs={12}
            sm={4}
            display='flex'
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display='flex' justifyContent='center'>
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={
                pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </div>
  );
};

export default SettelmentWithSuppliersTable;
